"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HasAdjustingCreditTerms = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.HasAdjustingCreditTerms = {
    priority: Number.MAX_VALUE,
    label: 'fields.payload.mor_entity_answers.has_adjusting_credit_terms.label',
    fallbackLabel: 'When a merchant\'s risk rating worsens, is adjusting any other credit terms your predefined risk mitigating measures?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Boolean,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
